import { environment } from '../../../../../environments/environment';

const rolePath = '/role';
const menuPath = '/menu/tree';
const accessPath = '/access/tree';
const myAccessPath = '/user/myAccess';

export const RoleListServicePathConst = `${environment.api.apiV1}${rolePath}`;
export const RoleMenuServicePathConst = `${environment.api.apiV1}${menuPath}`;
export const RoleAccessServicePathConst = `${environment.api.apiV1}${accessPath}`;
export const RoleMyAccessServicePathConst = `${environment.api.apiV1}${myAccessPath}`;
export const RoleBulkUpdatePathConst = `${environment.api.apiV1}${rolePath}/bulkUpdate`;
